"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisclosureWebhookIMSchema = void 0;
const disclosurewebhookdata_1 = require("../core-model-schemas/disclosurewebhookdata");
exports.DisclosureWebhookIMSchema = disclosurewebhookdata_1.DisclosureWebhookDataSchema.omit({
    id: true,
    updatedAt: true,
    createdAt: true,
});
